<template>
  <div class="ImageGallery">
    <div class="ImageGallery-thumb">
      <img
        class="ImageGallery-image"
        :src="baseUrl + 'storage/images/' + dates.folder + '/' + dates.url"
        :alt="dates.description || 'Изображение галереи'"
      />
      <button
        type="button"
        class="ImageGallery-delete"
        aria-label="Удалить изображение"
        @click="deleteImage(dates.id)"
      >
        <img src="@/assets/cross.png" alt="" />
      </button>
    </div>
    <span class="ImageGallery-caption">{{ dates.description }}</span>
  </div>
</template>
<script>
export default {
  props: ["dates"],
  data() {
    return {
      baseUrl: process.env.VUE_APP_API,
    };
  },

  methods: {
    deleteImage(id) {
      this.$emit("deleteImage", id);
    },
  },
};
</script>

<style>
.ImageGallery {
  display: flex;
  flex-flow: column nowrap;
  box-sizing: border-box;
  width: 240px;
  overflow: hidden;
  border: 1px solid #e3dede;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(26, 20, 20, 0.06);
  transition: box-shadow 0.15s ease, transform 0.15s ease;
}

.ImageGallery:hover {
  box-shadow: 0 8px 20px rgba(26, 20, 20, 0.12);
  transform: translateY(-2px);
}

.ImageGallery-thumb {
  position: relative;
  display: block;
  width: 100%;
  height: 160px;
  background: #f4f1f1;
}

.ImageGallery-image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.ImageGallery-delete {
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 1px 4px rgba(26, 20, 20, 0.2);
  cursor: pointer;
  transition: background-color 0.15s ease, transform 0.15s ease;
}

.ImageGallery-delete:hover {
  background: #ffffff;
  transform: scale(1.08);
}

.ImageGallery-delete:focus-visible {
  outline: 2px solid #bd0000;
  outline-offset: 2px;
}

.ImageGallery-delete img {
  width: 12px;
  height: 12px;
}

.ImageGallery-caption {
  display: block;
  box-sizing: border-box;
  width: 100%;
  padding: 10px 14px;
  overflow: hidden;
  font: 14px/20px OpenSans-Semibold;
  color: #8f8787;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ImageGallery-caption:empty {
  display: none;
}
</style>
